module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ach"
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OOKS BY")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OROTHY")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARLOCK")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("After the Parade")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Almost Eden")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Annie Lash")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Dreamkeepers")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Dream River")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("The Edge of Town")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Forever Victoria")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("A Gentle Giving")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Glorious Dawn")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("High on a Hill")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Homeplace")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Hope’s Highway")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Larkspur")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Leaving Whiskey Bend")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("The Listening Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Lonesome River")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Love and Cherish")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Loveseekers")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Midnight Blue")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("More than Memory")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Mother Road")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Nightrose")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("On Tall Pine Lake")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("A Place Called Rainwater")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Promisegivers")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Restless Wind")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Ribbon in the Sky")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("River Rising")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("River of Tomorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("The Searching Hearts")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Sins of Summer")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Song of the Road")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Sweetwater")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Tenderness")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("This Loving Land")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Train from Marietta")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Wayward Wind")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("A Week from Sunday")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Wild Sweet Wilderness")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Will You Still Be Mine?")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Wind of Promise")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Wishmakers")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("With Heart")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("With Hope")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("With Song")])]), _vm._v(" "), _c('p', {
    staticClass: "acl"
  }, [_c('em', [_vm._v("Yesteryear")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-737058e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MoonLookedDown_adca-1.vue
// module id = 66
// module chunks = 0